export const NACH_STATUS_MAPPING = {
    INITIATED: "IN DRAFT",
    PENDING: "IN DRAFT",
    UNINITIATED: "NOT STARTED",
    FAILED: "FAILED",
    REGISTERED: "SUCCESS",
    AUTHENTICATED: {
        ENACH: "IN DRAFT",
        FAC_ENACH: "IN DRAFT",
        PHYSICAL_NACH: "IN DRAFT",
        FAC_PHYSICAL_NACH: "IN DRAFT",
        DAILY_ENACH: "IN DRAFT",
        DAILY_PHYSICAL_NACH: "IN DRAFT",
        WEEKLY_ENACH: "IN DRAFT",
        WEEKLY_PHYSICAL_NACH: "IN DRAFT"
    }
};

export const NACH_VENDOR_MAPPING = {
    DIGIO: "Digio",
    LOTUS_PAY: "Lotus Pay",
    ESCROW_PAY: "Escrow Pay",
    DUMMY: "Dummy"
};

export const NACH_TYPE_MAPPING = {
    ENACH: "E-NACH",
    PHYSICAL_NACH: "Paper",
    FAC_ENACH: "FAC-ENACH",
    FAC_PHYSICAL_NACH: "FAC-PAPER",
    DAILY_ENACH: "DAILY-E-NACH",
    DAILY_PHYSICAL_NACH: "DAILY-PAPER",
    WEEKLY_ENACH: "WEEKLY-E-NACH",
    WEEKLY_PHYSICAL_NACH: "WEEKLY-PAPER"
};

// Helper function to extract NACH Type (Paper/Enach) from mandate type
export const getNachTypeFromMandateType = (mandateType) => {
    if (!mandateType) return "-";
    
    if (mandateType.includes("PHYSICAL") || mandateType === "PHYSICAL_NACH") {
        return "Paper";
    } else if (mandateType.includes("ENACH") || mandateType === "ENACH") {
        return "Enach";
    }
    return "Paper"; // default
};

// Helper function to extract Frequency from mandate type
export const getNachFrequencyFromMandateType = (mandateType) => {
    if (!mandateType) return "-";
    
    if (mandateType.includes("DAILY")) {
        return "DAILY";
    } else if (mandateType.includes("WEEKLY")) {
        return "WEEKLY";
    } else if (mandateType.includes("FAC")) {
        return "ADHOC";
    } else if (mandateType === "ENACH" || mandateType === "PHYSICAL_NACH") {
        return "MONTHLY";
    }
    return "MONTHLY"; // default
};

export const MODAL_TEXTS = {
    TITLE: "Alert!",
    DELETE_WITH_REPAYMENTS: "Ongoing repayments found for this Auto-debit (NACH). Are you sure you want to delete?",
    DELETE_CONFIRMATION: "Are you sure you want to delete?",
    PRIMARY_BUTTON: "Delete",
    SECONDARY_BUTTON: "Cancel"
};

export const NOTIFICATION_TEXTS = {
    DELETE_SUCCESS: "NACH deleted successfully",
    DELETE_ERROR: "Failed to delete NACH",
    CHECK_REPAYMENTS_ERROR: "Failed to check active repayments"
};

export const TOOLTIP_TEXTS = {
    NO_DELETE_ACCESS: "You do not have required access"
};
